import { render, staticRenderFns } from "./informTable.vue?vue&type=template&id=5b5bf4d0"
import script from "./informTable.vue?vue&type=script&lang=js"
export * from "./informTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports